module.exports = __webpack_public_path__ + "static/media/pen-alt.6e710d87.svg";